import { LogarData } from '@/components/pages/Logar';
import { api } from '@/config/axiosConfig';
import {
  APIResponseAutenticacao,
  APIResponseListagemIdentidadeGenero,
  APIResponsePolitica,
  IdentidadeGenero,
  Politica,
} from './types/autenticacao';
import { APIResponse } from './types';
import requisicaoSegura from '@/auth/requisicaoSegura';
import { FormCadastrarUsuario } from '@/components/pages/Cadastrar/hook/useCadastrarPageHook';
import { RedefinirSenhaData } from '@/components/pages/RedefinirSenha/hook/useRedefinirSenhaHook';
import { EsqueciMinhaSenhaData } from '@/components/pages/EsqueciMinhaSenha/hook/useEsqueciMinhaSenhaHook';

export async function listarIdentidadesGenero(): Promise<
  Array<IdentidadeGenero>
> {
  const formListagem = new FormData();
  formListagem.append('siglaIdioma', 'padrao');
  formListagem.append('pagina', '0');
  formListagem.append('paginacao', '-1');

  const response = await api.post<APIResponseListagemIdentidadeGenero>(
    '/TipoGenero/Listar',
    formListagem,
  );
  return response.data.dados.lista;
}

export async function recuperarTermos(
  termoCodigo: 'termosDeServico' | 'politicaPrivacidade',
): Promise<Politica> {
  const formTermo = new FormData();
  formTermo.append('codigo', termoCodigo);
  const response = await api.post<APIResponsePolitica>(
    'Politica/Ler',
    formTermo,
  );
  return response.data.modelos[0];
}

export async function cadastrar(
  dataFormCadastrarUsuario: FormCadastrarUsuario,
): Promise<APIResponse> {
  const formCadastro = new FormData();
  Object.entries(dataFormCadastrarUsuario).forEach(([chave, valor]) => {
    if (!valor) return;
    return formCadastro.append(chave, valor);
  });

  const response = await api.post<APIResponse>(
    '/Usuario/Cadastrar',
    formCadastro,
  );
  return response.data;
}

export async function resetarSenha(
  dataFormEsqueciMinhaSenha: EsqueciMinhaSenhaData,
): Promise<APIResponse> {
  const formResetarSenha = new FormData();
  Object.entries(dataFormEsqueciMinhaSenha).forEach(([chave, valor]) => {
    formResetarSenha.append(chave, valor);
  });

  const response = await api.post<APIResponse>(
    '/Usuario/ResetarSenhaMobile',
    formResetarSenha,
  );
  return response.data;
}

export async function redefinirSenha(
  dataFormEsqueciMinhaSenha: RedefinirSenhaData,
): Promise<APIResponse> {
  const formRedefinirSenha = new FormData();
  Object.entries(dataFormEsqueciMinhaSenha).forEach(([chave, valor]) => {
    formRedefinirSenha.append(chave, valor);
  });

  const response = await api.post<APIResponse>(
    '/Home/TrocarSenhaMobile',
    formRedefinirSenha,
  );
  return response.data;
}

export async function logar(dataForm: LogarData) {
  const formLogar = new FormData();
  Object.entries(dataForm).forEach(([chave, valor]) => {
    formLogar.append(chave, valor);
  });
  formLogar.append('origin', 'omelete_shop');
  const response = await api.post<APIResponseAutenticacao>(
    '/Home/Login',
    formLogar,
  );
  return response.data;
}

export async function excluirConta(): Promise<APIResponse> {
  return requisicaoSegura({
    endpoint: '/Usuario/ExcluirMinhaConta',
    dataForm: {},
  });
}
